export default __webpack_public_path__ + "static/media/Chestguard of the Painlegion.7c606517.jpg";